<template>
    <vue-ads-pagination 
        :total-items="totalItems"
        :items-per-page="itemsPerPage"
        :max-visible-pages="maxVisiblePages" 
        :page="page"
        :loading="loading"
        >
        <template slot-scope="props">
        <div class="vue-ads-pr-2 vue-ads-leading-loose">
            <!-- Items {{ props.start }} tot {{ props.end }} van de {{ props.total }} -->
        </div>
        </template>
        <template
            slot="buttons"
            slot-scope="props"
            >
            <vue-ads-page-button
                v-for="(button, key) in props.buttons"
                :key="key"
                v-bind="button"
                :class="{'bg-yellow-dark': button.active}"
                @page-change="page = button.page; pageChange(button.page)"
                @range-change="start = button.start; end = button.end"
            />
        </template>
    </vue-ads-pagination>
</template>

<script>
import VueAdsPagination, { VueAdsPageButton } from 'vue-ads-pagination';

export default {
    components: {
        VueAdsPagination,
        VueAdsPageButton,
    },
    props: ['totalItems','itemsPerPage','maxVisiblePages'],
    data() {
        return {
            loading: false,
            page: 0,
            start: 0,
            end: 0,
        }
    },
    methods:{
        pageChange(page) {
            this.page = page;
            this.$emit('current_page',(this.page + 1))
        },
        rageChange(start, end) {
            this.start = start;
            this.end = end;
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/shared/AdsPagination.vue